import { Observable } from 'rxjs';
import { inject } from '@angular/core';
import { CrmMessageService } from '@touch4it/ng-swp/message';

import { DetailHandler } from '~/shared/classes/detail.handler';
import { UserModel } from '~/api/users/user.model';
import { UsersApiService } from '~/api/users/users-api.service';
import { UserUpdateDto } from '~/api/users/user-update.dto';
import { catchErrorEmpty } from '~/shared/utils/rxjs/catch-error-empty';

import { UserDetailFormData } from './user-detail-form.provider';

export class UserDetailHandler extends DetailHandler<UserDetailFormData, UserModel> {
  private user = inject(UsersApiService);
  private message = inject(CrmMessageService);

  override createSaveRequest(value: UserDetailFormData): Observable<UserModel> {
    const body: UserUpdateDto = {
      firstName: value.firstName!,
      lastName: value.lastName!,
      email: value.email!,
    };

    if (value.role === 'management' || value.role === 'staff') {
      body['roles.management'] = value.role === 'management';
      body['roles.staff'] = value.role === 'staff';
    }

    if (value.password) {
      body.password = value.password;
    }

    return this.user.updateUser(this.data()._id, body).pipe(catchErrorEmpty(() => this.message.error('generic.sww')));
  }
}
